// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"50d6fcec","795":"30e9d720"}[chunkId] + ".chunk.css";
};